module.exports = __webpack_public_path__ + "img/r6_921_memory.d850f853.jpg";